import script from "./AdminSalesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSalesPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSalesPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__